import { useEffect, useState } from "react";
import { useAuth } from "features/auth/hooks/useAuth";
import { collaboratorProfilesApi } from "features/collaborator/api/collaborator-profiles-api";
import type { CollaboratorProfileWithRelations } from "features/collaborator/model/collaborator-profile.types";
import type { CollaboratorAccessUserProfile } from "features/system-admin/collaborators/model/collaborator-access.types";

export function useCurrentUser() {
  const [user, setUser] = useState<CollaboratorAccessUserProfile | null>(null);
  const { user: authUser } = useAuth();

  useEffect(() => {
    const loadCurrentUser = async () => {
      if (!authUser) {
        setUser(null);
        return;
      }

      try {
        const response = await collaboratorProfilesApi.getMe();
        const collaboratorProfile =
          (response as CollaboratorProfileWithRelations | null) ?? null;

        setUser({
          id: authUser.id,
          uuid: String(authUser.id),
          username: authUser.username,
          created_at: "",
          updated_at: "",
          memberships: [],
          roles: [],
          collaborator_profile: collaboratorProfile,
        });
      } catch (error) {
        console.error("Error loading current user:", error);
        setUser({
          id: authUser.id,
          uuid: String(authUser.id),
          username: authUser.username,
          created_at: "",
          updated_at: "",
          memberships: [],
          roles: [],
          collaborator_profile: null,
        });
      }
    };

    void loadCurrentUser();
  }, [authUser]);

  return user;
}
